// Please put date in YYYY-MM-DD format
export const multigenPhotos = [
    {
        name: "Multigen Logo",
        desc: "Multigen Logo",
        date: "2018-08-11",
    	imgname: "multigen-logo.png",
    	credits: "Steve",
    },
]
